import { motion } from "framer-motion";
import { Pencil, Trash2, Receipt } from "lucide-react";
import { getCategorie } from "@/lib/categories";
import { formateazaRON } from "@/lib/settlement";

// O cheltuială din istoric (cu iconița categoriei, bon atașat, editare/ștergere).
export function ExpenseListItem({ item, numeMembru, formateazaData, onOpenReceipt, onEdit, onDelete }) {
  const cat = getCategorie(item.category);
  const CatIcon = cat.icon;
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid={`expense-item-${item.id}`}
      className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4 flex items-center gap-3"
    >
      <div className={`h-10 w-10 rounded-full flex items-center justify-center shrink-0 ${cat.color}`}>
        <CatIcon className="h-5 w-5" strokeWidth={2.5} />
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-slate-900 truncate">{item.description}</p>
        <p className="text-xs text-slate-500 mt-0.5">
          {numeMembru(item.paidBy)} a plătit • {formateazaData(item.createdAt)}
        </p>
        {item.currency && item.currency !== "RON" && item.originalAmount != null && item.originalAmount > 0 && (
          <p data-testid={`expense-currency-${item.id}`} className="text-[11px] text-amber-600 font-medium mt-0.5">
            {item.originalAmount} {item.currency} · curs 1 {item.currency} = {(item.amount / item.originalAmount).toFixed(4)} RON
          </p>
        )}
      </div>
      <div className="text-right shrink-0">
        <p className="font-heading font-extrabold text-slate-900">{formateazaRON(item.amount)}</p>
        <div className="flex items-center justify-end gap-1 mt-1">
          {item.receiptId && (
            <button
              data-testid={`view-receipt-btn-${item.id}`}
              aria-label="Vezi bonul"
              onClick={() => onOpenReceipt(item.receiptId)}
              className="text-slate-400 hover:text-emerald-600 transition-colors p-1"
              title="Vezi bonul"
            >
              <Receipt className="h-4 w-4" />
            </button>
          )}
          <button
            data-testid={`edit-expense-btn-${item.id}`}
            aria-label="Editează cheltuiala"
            onClick={() => onEdit(item)}
            className="text-slate-400 hover:text-emerald-600 transition-colors p-1"
          >
            <Pencil className="h-4 w-4" />
          </button>
          <button
            data-testid={`delete-expense-btn-${item.id}`}
            aria-label="Șterge cheltuiala"
            onClick={() => onDelete(item.id)}
            className="text-slate-400 hover:text-rose-500 transition-colors p-1"
          >
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
      </div>
    </motion.div>
  );
}
